import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginRoute } from "../../../utils/APIRoutes";

const Index = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("chat-app-current-user")) {
      navigate("/");
    }
  }, []);
  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const validateForm = (e) => {
    const { username, password } = values;
    if (username === "") {
      window.alert("Both username and password required!");
      return false;
    } else if (password === "") {
      window.alert("Both username and password required");
      return false;
    }
    return true;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (validateForm()) {
      const { username, password } = values;
      const { data } = await axios.post(loginRoute, {
        username,
        password,
      });
      if (data.status === false) {
        window.alert(data.msg);
      }
      if (data.status === true) {
        localStorage.setItem(
          "chat-app-current-user",
          JSON.stringify(data.user)
        );
        navigate("/");
      }
    }
    setLoading(false);
  };
  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="row  Average-chart mt-4 mb-5">
            <div className="col-md-12">
              <div className="headerpage">
                <h2>Login</h2>
                <img class="logoimg11" src="img/paygold-logo.png" alt="" />
              </div>
              <div className="FormBOx">
                <form action="" onSubmit={(event) => handleSubmit(event)}>
                  <div>
                    <label>Username:</label>
                    <input
                      type="text"
                      name="username"
                      placeholder="Username"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div>
                    <label>Password:</label>
                    <input
                      type="password"
                      name="password"
                      placeholder="Password"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="btnsubmit text-center">
                    {loading ? (
                      <button disabled={true} className="text-gray-500">
                        Loading ...
                      </button>
                    ) : (
                      <button>Login</button>
                    )}
                    <p>
                      Don&apos;t have an account?{" "}
                      <Link to="/sign-up">Sign up here</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
